import { httpGet, httpPost } from "@/request/http";

let path = "/directoryCustomers";

export default {
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  getCustomers(id) {
    return httpGet(`${path}/directorys/${id}/customers`);
  },
  add(items) {
    return httpPost(`${path}/addbatch`, items);
  },
  remove(items) {
    return httpPost(`${path}/deletebatch`, items);
  },
};
